import { useRef, useState } from "react";
import { useHistory } from "react-router";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { PROPERTY_TYPE_VALUES } from "@/api/mappings/property";
import { PropallyApiFactory } from "@/module/CustomApiFactory";
import { PropertyManagementDetailSnackbarState, useRequestInitialLoading } from "@/view_models/atoms";
import { SelectedProperty } from "@/view_models/propertySelectors";

import { loanError } from "../utils/loanError";

export const usePatchProperty = (keepFormOnError = false) => {
  const pending = useRef(false);
  const [error, setError] = useState("");
  const [errorReason, setErrorReason] = useState<string>();
  const clearError = () => {
    setError("");
    setErrorReason(undefined);
  };
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const requestInitialLoading = useRequestInitialLoading();
  const selected_property = useRecoilValue(SelectedProperty);
  const setManagementDetailSnackBarState = useSetRecoilState(PropertyManagementDetailSnackbarState);

  const patchProperty = async (data: any) => {
    if (pending.current) return false;
    pending.current = true;
    setIsLoading(true);
    clearError();
    const fp = PropallyApiFactory();

    try {
      const result = await fp.v1PropertiesPropertyIdPatch(selected_property.id, data, {
        withCredentials: true,
      });

      if (result.status === 200) {
        requestInitialLoading();
        return true;
      }
      return false;
    } catch (e) {
      if (keepFormOnError) {
        const failure = loanError(e);
        setError(failure.message);
        setErrorReason(failure.reason);
        return false;
      }
      setManagementDetailSnackBarState({
        message: "物件情報を変更できませんでした",
        status: "error",
        isOpen: true,
      });
      if (selected_property.property.property_type === PROPERTY_TYPE_VALUES.consideration) {
        history.push("/management/consideration/detail");
      } else {
        history.push("/management/own/detail");
      }
      return false;
    } finally {
      pending.current = false;
      setIsLoading(false);
    }
  };

  return {
    patchProperty,
    isLoading,
    error,
    errorReason,
    clearError,
  };
};
